import { render, staticRenderFns } from "./ivst.vue?vue&type=template&id=65ed5b46&scoped=true"
import script from "./ivst.vue?vue&type=script&lang=js"
export * from "./ivst.vue?vue&type=script&lang=js"
import style0 from "./ivst.vue?vue&type=style&index=0&id=65ed5b46&prod&scoped=true&lang=css"
import style1 from "./ivst.vue?vue&type=style&index=1&id=65ed5b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed5b46",
  null
  
)

export default component.exports